"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import "../styles/dashboardEventos.css";
import { FaTrash, FaPlus } from "react-icons/fa";

const PatrocinadoresAdmin = () => {
  const [sponsors, setSponsors] = useState([]);
  const [novoLink, setNovoLink] = useState("");
  const [novaImagem, setNovaImagem] = useState("");

  // Carregar patrocinadores
  const carregarSponsors = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/sponsors`);
      setSponsors(res.data);
    } catch (err) {
      console.error("Erro ao buscar patrocinadores:", err);
    }
  };

  useEffect(() => {
    carregarSponsors();
  }, []);

  // Adicionar patrocinador
  const adicionarSponsor = async () => {
    if (!novoLink || !novaImagem) {
      alert("Preencha todos os campos!");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/sponsors`, {
        imagem: novaImagem,
        link: novoLink,
      });
      setNovoLink("");
      setNovaImagem("");
      carregarSponsors();
    } catch (err) {
      console.error("Erro ao adicionar patrocinador:", err);
    }
  };

  // Remover patrocinador
  const removerSponsor = async (id) => {
    if (!window.confirm("Deseja remover este patrocinador?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/sponsors/${id}`);
      carregarSponsors();
    } catch (err) {
      console.error("Erro ao remover patrocinador:", err);
    }
  };

  return (
    <div className="admin-layout1">
      <div className="admin-content1">
        <h2 className="titulo-eventos">Gerenciar Patrocinadores</h2>

        {/* Formulário de adição */}
        <div className="busca-container">
          <input
            type="text"
            className="campo-busca"
            placeholder="URL da imagem do patrocinador"
            value={novaImagem}
            onChange={(e) => setNovaImagem(e.target.value)}
          />
          <input
            type="text"
            className="campo-busca"
            placeholder="Link do patrocinador"
            value={novoLink}
            onChange={(e) => setNovoLink(e.target.value)}
          />
          <button onClick={adicionarSponsor} className="botao-criar-evento">
            <FaPlus /> Adicionar
          </button>
        </div>

        {/* Lista em tabela */}
        <div className="table-container">
          <table className="tabela-eventos">
            <thead>
              <tr>
                <th>Imagem</th>
                <th>Link</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {sponsors.length === 0 ? (
                <tr>
                  <td colSpan="3">Nenhum patrocinador cadastrado.</td>
                </tr>
              ) : (
                sponsors.map((s) => (
                  <tr key={s._id}>
                    <td>
                      <img
                        src={s.imagem}
                        alt="Patrocinador"
                        className="imagem-evento"
                      />
                    </td>
                    <td>
                      <a
                        href={s.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {s.link}
                      </a>
                    </td>
                    <td>
                      <button
                        className="menu-icon"
                        onClick={() => removerSponsor(s._id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PatrocinadoresAdmin;
